import {loanBreakoutDetails, partnerOfferings} from "./utils";

const InfoSection = ({partnerName}: {partnerName?: string | null}) => {
  const partnerOffers =
    partnerOfferings[partnerName as keyof typeof partnerOfferings]?.offers;

  return (
    <div className="flex-1 text-black p-4 md:p-8 rounded-2xl">
      {!!partnerOffers?.length ? (
        <div>
          <h2 className="text-2xl font-semibold text-black pl-7">We Offer</h2>
          <ul className="list-disc pl-5 md:pl-12 text-black">
            {partnerOffers.map((offer, i) => (
              <li key={i} className="pt-3 font-semibold text-[1.2rem]">
                {offer}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <>
          <h2 className="text-xl md:text-2xl font-semibold">
            Important Information on Unsecured Business Loans
          </h2>
          <p className="mt-2 text-sm">
            Repayment Period: 3 months (min.) to 36 months (max.) <br />
            Max. Annual Percentage Rate (APR): 78%
          </p>

          <h2 className="mt-6 text-xl md:text-2xl font-semibold">
            Representative Example
          </h2>
          <p className="mt-2 text-sm">
            This is an example to show cost involved and interest calculations.
            Actual amount, tenure, interest rate & processing fee will depend on
            the risk profile of the user.
          </p>

          <div className="grid grid-cols-1 gap-1 md:gap-4 md:grid-cols-2 py-2 md:py-4">
            {loanBreakoutDetails.map((details, i) => (
              <div key={i} className="flex items-start gap-2">
                <span className="text-orange-500 text-lg md:text-xl">✓</span>
                <span className="text-sm">
                  <strong>{details.title}</strong>: {details.value}
                </span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default InfoSection;
